import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface LanguageListItem {
  id: number;
  name: string;
  iso_code: string | null;
  iso_639_1: string | null;
  candidate_count: number;
}

export interface PaginatedLanguagesResponse {
  items: LanguageListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function listLanguages(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; sort_by?: string; sort_order?: string; resolved_only?: boolean }
): Promise<PaginatedLanguagesResponse> {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 25));
  if (params?.sort_by) q.set("sort_by", params.sort_by);
  if (params?.sort_order) q.set("sort_order", params.sort_order);
  if (params?.resolved_only) q.set("resolved_only", "true");
  const url = `${API_URL}/languages?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des langues");
  return res.json();
}

export interface CleanLanguagesResponse {
  resolved: number;
  merged: number;
  split: number;
  deduped: number;
  still_unresolved: number;
  details: { id: number; old_name: string; new_name?: string; new_names?: string[]; action: string }[];
}

export async function cleanLanguages(navigate: NavigateFunction): Promise<CleanLanguagesResponse> {
  const res = await apiFetch(`${API_URL}/languages/clean`, { method: "POST" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du nettoyage des langues");
  return res.json();
}

export interface GuessLanguagesResponse {
  candidates_updated: number;
  total_without_languages: number;
}

export async function guessLanguagesBulk(navigate: NavigateFunction): Promise<GuessLanguagesResponse> {
  const res = await apiFetch(`${API_URL}/languages/guess-bulk`, { method: "POST" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors de la devinette des langues");
  return res.json();
}
